import { useAppSelector } from "../../../app/hooks";
import { UserRole } from "../../../app/userSlice";
import Select from "../../../components/input/Select";
import { SimpleOption } from "../../../components/input/SimpleListbox";

interface DistrictSchoolFiltersProps {
	districtOptions: SimpleOption[];
	schoolOptions: SimpleOption[];
	districtFilter: number;
	schoolFilter: number;
	setDistrictFilter: (value: number) => void;
	setSchoolFilter: (value: number) => void;
	labelClasses?: string;
	districtFieldClasses?: string;
	schoolFieldClasses?: string;
	listBoxClasses?: string;
}

export function DistrictSchoolFilters({
	districtOptions,
	schoolOptions,
	districtFilter,
	schoolFilter,
	setDistrictFilter,
	setSchoolFilter,
	labelClasses,
	listBoxClasses = "w-72",
}: DistrictSchoolFiltersProps) {
	const { role, schools, districts } = useAppSelector((state) => state.user);

	return (
		<div className="flex gap-3 items-end w-fit print:hidden">
			{(districtOptions.length > 1 ||
				(role === UserRole.DistrictAdmin && (districts?.length ?? 0) > 1)) && (
				<Select
					value={districtFilter}
					setValue={(v) => setDistrictFilter(v as number)}
					label="District"
					simpleListBoxId="districtFilter"
					options={districtOptions}
					labelClasses={labelClasses}
					fieldClasses="w-full md:flex-1"
					simpleListBoxClasses={listBoxClasses}
				/>
			)}
			{districtFilter != 0 &&
				(schoolOptions.length > 1 ||
					districtOptions.length > 1 ||
					(role === UserRole.SchoolAdmin && (schools?.length ?? 0) > 1)) && (
					<Select
						value={schoolFilter}
						setValue={(v) => setSchoolFilter(v as number)}
						label="School"
						simpleListBoxId="schoolFilter"
						options={schoolOptions}
						labelClasses={labelClasses}
						fieldClasses="w-full md:flex-1 pt-2 md:pt-0"
						simpleListBoxClasses={listBoxClasses}
					/>
				)}
		</div>
	);
}
